import type { FeatureFlag, KillswitchState } from 'src/interfaces/usBankKillswitch'

/**
 * The backend checks `partnerFlag?.enabled || globalFlag?.enabled`: a global `true` stops every
 * partner, and a per-partner `false` cannot exempt one. So the switch shows the global row, and
 * partner rows are reported only when they ADD a stop.
 */
export const deriveKillswitchState = (rows: FeatureFlag[]): KillswitchState => {
  const globalFlag =
    rows.find((row) => {
      return row.partnerId === null
    }) ?? null

  const activePartnerIds = rows
    .filter((row) => {
      return row.partnerId !== null && row.enabled
    })
    .map((row) => {
      return row.partnerId as string
    })

  return {
    globalFlag,
    isGloballyActive: Boolean(globalFlag?.enabled),
    activePartnerIds,
  }
}

/**
 * Whether refund Execute may be decided on the stored flag rows (permission gating spec §10.3).
 * It applies to refund execution only, because the server enforces the killswitch there
 * (para-node's RefundService refuses execution while payment processing is stopped). It does not
 * apply to captured-event replay: that endpoint does not check the killswitch, so replay stays
 * blocked unless the status is actually known.
 *
 * With `feature_flags_view`, only once the rows loaded without error: before that, "no global row"
 * would read as "processing is running". Without it, `PaymentsOpsLayout` never fetches the rows,
 * so there is nothing to wait for — the empty rows read as "no switch on" and the server stays the
 * authority.
 */
export const canRelyOnKillswitchStatus = (
  canViewFlags: boolean,
  isStatusKnown: boolean,
): boolean => {
  if (!canViewFlags) {
    return true
  }

  return isStatusKnown
}
